import { z } from 'zod';
import { CourseType, CourseStatus, CourseMode, CandidateStage, AttendanceStatus, PlacementStatus, } from '../enums.js';
const isoDate = z.string().datetime().or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
export const createCourseInput = z.object({
    name: z.string().min(1).max(200),
    code: z.string().max(40).optional().nullable(),
    type: z.nativeEnum(CourseType),
    status: z.nativeEnum(CourseStatus).default(CourseStatus.ISCRIZIONI),
    mode: z.nativeEnum(CourseMode),
    partnerName: z.string().max(200).optional().nullable(),
    clientId: z.string().optional().nullable(),
    projectId: z.string().optional().nullable(),
    startDate: isoDate,
    endDate: isoDate,
    hoursTotal: z.coerce.number().int().min(1).max(2000),
    enrolledCount: z.coerce.number().int().min(0).default(0),
    revenue: z.coerce.number().min(0).default(0),
    cost: z.coerce.number().min(0).default(0),
    description: z.string().max(5000).optional().nullable(),
    objectives: z.string().max(5000).optional().nullable(),
    teacherUserIds: z.array(z.string()).default([]),
});
export const updateCourseInput = createCourseInput.partial();
export const lessonInput = z.object({
    courseId: z.string(),
    date: isoDate,
    startTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
    endTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
    topic: z.string().min(1).max(200),
    teacherId: z.string().optional().nullable(),
    room: z.string().max(80).optional().nullable(),
    mode: z.nativeEnum(CourseMode).default(CourseMode.IN_PRESENZA),
});
export const candidateInput = z.object({
    firstName: z.string().min(1).max(80),
    lastName: z.string().min(1).max(80),
    email: z.string().email().optional().nullable(),
    phone: z.string().max(40).optional().nullable(),
    city: z.string().max(80).optional().nullable(),
    skill: z.string().max(120).optional().nullable(),
    seniority: z.enum(['Junior', 'Mid', 'Senior']).optional().nullable(),
    availability: z.string().max(80).optional().nullable(),
    stage: z.nativeEnum(CandidateStage).default(CandidateStage.NUOVO_CANDIDATO),
    notes: z.string().max(5000).optional().nullable(),
});
export const enrollmentInput = z.object({
    candidateId: z.string(),
    courseId: z.string(),
});
export const attendanceInput = z.object({
    lessonId: z.string(),
    enrollmentId: z.string(),
    status: z.nativeEnum(AttendanceStatus),
    note: z.string().max(500).optional().nullable(),
});
export const placementInput = z.object({
    candidateId: z.string(),
    clientId: z.string().optional().nullable(),
    position: z.string().max(120).optional().nullable(),
    startDate: isoDate.optional().nullable(),
    status: z.nativeEnum(PlacementStatus).default(PlacementStatus.PROPOSTA),
    notes: z.string().max(2000).optional().nullable(),
});
//# sourceMappingURL=talent.js.map